/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  RequestSaleCreateOne,
  ResponseInternalServerError,
  ResponseSaleGetList,
  ResponseSaleGetOne,
  ResponseSaleItemsGetList,
  ResponseSaleRollback,
} from '../models/index'
import {
  RequestSaleCreateOneFromJSON,
  RequestSaleCreateOneToJSON,
  ResponseInternalServerErrorFromJSON,
  ResponseInternalServerErrorToJSON,
  ResponseSaleGetListFromJSON,
  ResponseSaleGetListToJSON,
  ResponseSaleGetOneFromJSON,
  ResponseSaleGetOneToJSON,
  ResponseSaleItemsGetListFromJSON,
  ResponseSaleItemsGetListToJSON,
  ResponseSaleRollbackFromJSON,
  ResponseSaleRollbackToJSON,
} from '../models/index'

export interface SaleCreateOneRequest {
  enterpriseId: string
  requestSaleCreateOne?: RequestSaleCreateOne
}

export interface SaleGetListRequest {
  enterpriseId: string
  fromDate?: string
  toDate?: string
  shopId?: string
  shopSalePointId?: string
  shopPaymentPointId?: string
  userId?: string
  customerId?: string
  supplierId?: string
}

export interface SaleItemsGetListRequest {
  enterpriseId: string
  saleId: string
}

export interface SaleRollbackRequest {
  enterpriseId: string
  saleId: string
}

/**
 *
 */
export class SaleApi extends runtime.BaseAPI {
  /**
   */
  async saleCreateOneRaw(
    requestParameters: SaleCreateOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseSaleGetOne>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling saleCreateOne().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/sale`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RequestSaleCreateOneToJSON(
          requestParameters['requestSaleCreateOne'],
        ),
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseSaleGetOneFromJSON(jsonValue),
    )
  }

  /**
   */
  async saleCreateOne(
    requestParameters: SaleCreateOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseSaleGetOne> {
    const response = await this.saleCreateOneRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async saleGetListRaw(
    requestParameters: SaleGetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseSaleGetList>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling saleGetList().',
      )
    }

    const queryParameters: any = {}

    if (requestParameters['fromDate'] != null) {
      queryParameters['fromDate'] = requestParameters['fromDate']
    }

    if (requestParameters['toDate'] != null) {
      queryParameters['toDate'] = requestParameters['toDate']
    }

    if (requestParameters['shopId'] != null) {
      queryParameters['shopId'] = requestParameters['shopId']
    }

    if (requestParameters['shopSalePointId'] != null) {
      queryParameters['shopSalePointId'] = requestParameters['shopSalePointId']
    }

    if (requestParameters['shopPaymentPointId'] != null) {
      queryParameters['shopPaymentPointId'] =
        requestParameters['shopPaymentPointId']
    }

    if (requestParameters['userId'] != null) {
      queryParameters['userId'] = requestParameters['userId']
    }

    if (requestParameters['customerId'] != null) {
      queryParameters['customerId'] = requestParameters['customerId']
    }

    if (requestParameters['supplierId'] != null) {
      queryParameters['supplierId'] = requestParameters['supplierId']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/sale`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseSaleGetListFromJSON(jsonValue),
    )
  }

  /**
   */
  async saleGetList(
    requestParameters: SaleGetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseSaleGetList> {
    const response = await this.saleGetListRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async saleItemsGetListRaw(
    requestParameters: SaleItemsGetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseSaleItemsGetList>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling saleItemsGetList().',
      )
    }

    if (requestParameters['saleId'] == null) {
      throw new runtime.RequiredError(
        'saleId',
        'Required parameter "saleId" was null or undefined when calling saleItemsGetList().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/sale/{saleId}/items`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'saleId'}}`,
      encodeURIComponent(String(requestParameters['saleId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseSaleItemsGetListFromJSON(jsonValue),
    )
  }

  /**
   */
  async saleItemsGetList(
    requestParameters: SaleItemsGetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseSaleItemsGetList> {
    const response = await this.saleItemsGetListRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async saleRollbackRaw(
    requestParameters: SaleRollbackRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseSaleRollback>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling saleRollback().',
      )
    }

    if (requestParameters['saleId'] == null) {
      throw new runtime.RequiredError(
        'saleId',
        'Required parameter "saleId" was null or undefined when calling saleRollback().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/sale/{saleId}/rollback`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'saleId'}}`,
      encodeURIComponent(String(requestParameters['saleId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseSaleRollbackFromJSON(jsonValue),
    )
  }

  /**
   */
  async saleRollback(
    requestParameters: SaleRollbackRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseSaleRollback> {
    const response = await this.saleRollbackRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }
}
